import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export type BackgroundTaskStatus = "pending" | "running" | "completed" | "failed";

export interface BackgroundTask {
  id: string;
  label: string;
  status: BackgroundTaskStatus;
  startedAt: string;
  finishedAt?: string;
}

export interface BackgroundTasksState {
  tasks: BackgroundTask[];
}

const initialState: BackgroundTasksState = {
  tasks: [],
};

export const backgroundTasksSlice = createSlice({
  name: "backgroundTasks",
  initialState,
  reducers: {
    addTask: (state, action: PayloadAction<BackgroundTask>) => {
      // prepend newest; cap at 50
      state.tasks.unshift(action.payload);
      if (state.tasks.length > 50) {
        state.tasks = state.tasks.slice(0, 50);
      }
    },
    updateTask: (
      state,
      action: PayloadAction<{ id: string; status: BackgroundTaskStatus; finishedAt?: string }>
    ) => {
      const task = state.tasks.find((t) => t.id === action.payload.id);
      if (task) {
        task.status = action.payload.status;
        if (action.payload.finishedAt) {
          task.finishedAt = action.payload.finishedAt;
        }
      }
    },
    clearTasks: (state) => {
      state.tasks = [];
    },
  },
});

export const { addTask, updateTask, clearTasks } = backgroundTasksSlice.actions;

export const selectBackgroundTasks = (state: RootState) => state.backgroundTasks.tasks;

export default backgroundTasksSlice.reducer;

